import $ from "jquery";
import ko from "knockout";
import "flow/bindings/dateBinding";
import dateHelper from "flow/utils/dateHelper";
import register from "flow/knockout/register";

register.registerKnockoutBinding("monthInterval", {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const startDateObservable = valueAccessor().start;
        const endDateObservable = valueAccessor().end;
        const onIntervalChanged = valueAccessor().onIntervalChanged;
        let subscriptions: KnockoutSubscription[];

        const observer = function () {
            if (onIntervalChanged) {
                const intervalIsValid = dateHelper.isValidInterval(
                    ko.utils.unwrapObservable(startDateObservable),
                    ko.utils.unwrapObservable(endDateObservable)
                );
                onIntervalChanged(intervalIsValid);
            }
        };

        const subscribe = function () {
            subscriptions = [];
            subscriptions.push(startDateObservable.subscribe(observer));
            subscriptions.push(endDateObservable.subscribe(observer));
        };

        const unsubscribe = function () {
            subscriptions[0].dispose();
            subscriptions[1].dispose();
        };

        subscribe();
        observer();

        $(element).keydown(function (event) {
            if (event.keyCode === $.ui.keyCode.TAB) {
                const startDateString = startDateObservable();

                try {
                    // We only want one notification, not two
                    unsubscribe();

                    // Complete start date
                    const startDate = dateHelper.completeDate(startDateString);
                    startDateObservable(dateHelper.getFormattedDateString(startDate));

                    // Set end date to end of month from start date.
                    const endDate = dateHelper.calculateEndDate(startDate);
                    endDateObservable(dateHelper.getFormattedDateString(endDate));

                    // Notify
                    observer();

                    // Resubscribe
                    subscribe();
                } catch (e) {
                    // Something went wrong and we've unsubscribed, so we resubscribe
                    subscribe();
                }
            }
        });

        ko.bindingHandlers.date.init(
            element,
            function () {
                return valueAccessor().start;
            },
            allBindingsAccessor,
            viewModel,
            bindingContext
        );
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        ko.bindingHandlers.date.update(
            element,
            function () {
                return valueAccessor().start;
            },
            allBindingsAccessor,
            viewModel,
            bindingContext
        );
    }
});
